import React from "react";
import { Typography } from "@mui/material";

export const StatusTag = ({ status }: { status: string }) => {
  return (
    <Typography
      sx={{
        textTransform: "capitalize",
        color:
          status === "Active" || status === "active" ? "#0E9F6E" : "#F05252",
        fontSize: "16px",
        fontWeight: "400",
      }}
    >
      {status || "-"}
    </Typography>
  );
};

export const LiveStatusTag = ({ status }: { status: string }) => {
  return (
    <Typography
      sx={{
        textTransform: "capitalize",
        color:
          status === "Live" || status === "live" || status === "Locked"
            ? "#0E9F6E"
            : "#F05252",
        fontSize: "16px",
        fontWeight: "400",
      }}
    >
      {status || "-"}
    </Typography>
  );
};
export const CompletedStatusTag = ({ status }: { status: string }) => {
  return (
    <Typography
      variant="body2"
      fontWeight="medium"
      sx={{
        textTransform: "capitalize",
        color:
          status === "Completed" || status === "completed"
            ? "#03543F"
            : "#9B1C1C",
        bgcolor:
          status === "Completed" || status === "completed"
            ? "#DEF7EC"
            : "#FDE8E8",
        display: "inline-block",
        borderRadius: "6px",
        p: "2px 8px",
        textAlign: "center",
      }}
    >
      {status || "-"}
    </Typography>
  );
};

export const CustomStatusChip = ({
  label,
  color,
  bgColor,
}: {
  label: string;
  color: string;
  bgColor: string;
}) => {
  return (
    <Typography
      variant="body2"
      fontWeight="medium"
      sx={{
        color: color || "text.primary",
        bgcolor: bgColor || "#F3F4F6",
        width: "fit-content",
        borderRadius: "6px",
        p: "2px 8px",
        textAlign: "center",
      }}
    >
      {label}
    </Typography>
  );
};
